<div class="w-full flex justify-end pb-4 pr-4 pt-2">
  <button
    type="button"
    class="group inline-flex items-center gap-2 text-primary-600 font-medium cursor-pointer"
    (click)="toggleMode()"
  >
    @if (advancedEnabled()) {
      <span class="group-hover:underline">Return to Basic Search</span>
    } @else {
      <span class="group-hover:underline">Advanced Search</span>
    }
    <span
      class="shrink-0 w-7 h-7 rounded-full border border-primary-600 flex items-center justify-center text-[10px] text-primary-600"
    >
      <i
        class="fa-regular fa-2xl"
        [class.fa-chevron-up]="advancedEnabled()"
        [class.fa-chevron-down]="!advancedEnabled()"
        aria-hidden="true"
      ></i>
    </span>
  </button>
</div>
<div class="w-full p-4 bg-surface-50 rounded-lg" [class.border]="bordered()" [class.border-surface-300]="bordered()">
  @if (!advancedEnabled()) {
    <div class="flex justify-between items-center gap-2">
      <div class="flex-1">
        <input #searchInput
               type="text"
               pInputText
               [(ngModel)]="basicSearchStr"
               class="w-full"
               pSize="small"
               autocomplete="off"
               aria-label="Search TAs"
               placeholder="Search by TA number, project code or staff name"
               (keydown.enter)="search.emit()"
        />
      </div>

      <p-button label="Search" size="small" severity="primary" icon="fa fa-magnifying-glass" (onClick)="search.emit()" [disabled]="!basicSearchStr().trim()" [loading]="loading()"></p-button>
      <p-button label="Clear" size="small" severity="secondary" icon="fa fa-x" (onClick)="clear.emit()"></p-button>
    </div>
  } @else {
    <div class="flex flex-col gap-4">
      <div class="flex gap-4">
        <div class="flex-col gap-2 flex-1 min-w-0">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Status</span></div>
          <p-multi-select [options]="statusOptions"
                    appendTo="body"
                    placeholder="Select TA Status"
                    class="w-full"
                    [(ngModel)]="advancedSearchParameters().taStatusList"
                    size="small"
                    showClear
          >
            <ng-template #selectedItem let-selectedItem>
              <p-chip >
                <div class="whitespace-nowrap text-xs font-normal font-['Roboto_Condensed']">{{selectedItem.label}}</div>
              </p-chip>
            </ng-template>
            <ng-template #item let-item >
              <p-chip >
                <div class="whitespace-nowrap text-xs font-normal font-['Roboto_Condensed']">{{item.label}}</div>
              </p-chip>
            </ng-template>
          </p-multi-select>
        </div>

        <div class="flex-col gap-2 flex-1 min-w-0">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Project</span></div>
          <p-multiSelect [options]="availableProjects()"
                         appendTo="body"
                         optionLabel="code"
                         placeholder="Select Projects"
                         class="w-full"
                         size="small"
                         [(ngModel)]="advancedSearchParameters().projectList"
                         showClear
                         [filter]="true"
                         filterPlaceHolder="Search projects..."
          ></p-multiSelect>
        </div>
      </div>
      <div class="flex gap-4">
        <div class="flex-col gap-2 flex-1 min-w-0">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Staff</span></div>
          <p-multiSelect [options]="staffMatch().options"
                         appendTo="body"
                         optionLabel="name"
                         placeholder="Select Staff"
                         class="w-full"
                         size="small"
                         [(ngModel)]="advancedSearchParameters().travellerList"
                         showClear
                         [filter]="true"
                         filterPlaceHolder="Search staff..."
                         [filterMatchMode]="fuzzyMatchMode.staff"
                         (onFilter)="staffQuery.set($event.filter ?? '')"
                         [virtualScroll]="true"
                         [virtualScrollItemSize]="40"
          >
            <ng-template let-user #item>
              <span [class.bg-yellow-50]="user?.userType === UserType.Casual" title="{{user.email}}">{{ user.name }} {{ getUserTypeSuffix(user) }}</span>
            </ng-template>
          </p-multiSelect>
        </div>

        <div class="flex-col gap-2 flex-1 min-w-0">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Approver</span></div>
          <p-multiSelect [options]="approverMatch().options"
                         appendTo="body"
                         optionLabel="name"
                         placeholder="Select Approvers"
                         class="w-full"
                         size="small"
                         [(ngModel)]="advancedSearchParameters().approverList"
                         showClear
                         [filter]="true"
                         filterPlaceHolder="Search approvers..."
                         [filterMatchMode]="fuzzyMatchMode.approver"
                         (onFilter)="approverQuery.set($event.filter ?? '')"
                         [virtualScroll]="true"
                         [virtualScrollItemSize]="40"
          >
            <ng-template let-user #item>
              <span [class.bg-yellow-50]="user?.userType === UserType.Casual" title="{{user.email}}">{{ user.name }} {{ getUserTypeSuffix(user) }}</span>
            </ng-template>
          </p-multiSelect>
        </div>

        <div class="flex-col gap-2 flex-1 min-w-0">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Created By</span></div>
          <p-multiSelect [options]="creatorMatch().options"
                         appendTo="body"
                         optionLabel="name"
                         placeholder="Select Staff Members"
                         class="w-full"
                         size="small"
                         [(ngModel)]="advancedSearchParameters().createdByList"
                         showClear
                         [filter]="true"
                         filterPlaceHolder="Search staff..."
                         [filterMatchMode]="fuzzyMatchMode.creator"
                         (onFilter)="creatorQuery.set($event.filter ?? '')"
                         [virtualScroll]="true"
                         [virtualScrollItemSize]="40"
                         [maxSelectedLabels]="4"
          >
            <ng-template let-user #item>
              <span [class.bg-yellow-50]="user?.userType === UserType.Casual" title="{{user.email}}">{{ user.name }} {{ getUserTypeSuffix(user) }}</span>
            </ng-template>
          </p-multiSelect>
        </div>
      </div>

      <div class="flex gap-4">

      <div class="flex-col gap-2 flex-1 min-w-0">
        <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Locations</span></div>
          <p-multiSelect [options]="locationMatch().options"
                         appendTo="body"
                         optionLabel="name"
                         placeholder="Select Locations"
                         [(ngModel)]="advancedSearchParameters().locationList"
                         class="w-full"
                         size="small"
                         showClear
                         [filter]="true"
                         filterPlaceHolder="Search locations..."
                         [filterMatchMode]="fuzzyMatchMode.location"
                         (onFilter)="locationQuery.set($event.filter ?? '')"
                         [virtualScroll]="true"
                         [virtualScrollItemSize]="40"
                         [maxSelectedLabels]="5"
          ></p-multiSelect>
        </div>

        <div class="flex-col gap-2 flex-1 min-w-0">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Travel Purpose</span></div>
          <p-multi-select [options]="purposeOptions()"
                          appendTo="body"
                          placeholder="Select Travel Purposes"
                          class="w-full"
                          size="small"
                          [(ngModel)]="advancedSearchParameters().purposeList"
                          showClear
                          [filter]="true"
                          filterPlaceHolder="Search purposes..."
          ></p-multi-select>
        </div>
      </div>

      <div class="flex gap-4">
        <div class="flex-col gap-2">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Start Date</span></div>
          <p-datepicker panelStyleClass=""
                        [(ngModel)]="advancedSearchParameters().dateStart"
                        [iconDisplay]="'input'"
                        [showIcon]="true"
                        [dateFormat]="'dd/mm/y'"
                        placeholder="DD/MM/YY"
                        size="small"
                        appendTo="body"
                        [minDate]=""
                        [maxDate]="advancedSearchParameters().dateEnd"
                        showClear
          ></p-datepicker>
        </div>

        <div class="flex-col gap-2">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">End Date</span></div>
          <p-datepicker panelStyleClass=""
                        [(ngModel)]="advancedSearchParameters().dateEnd"
                        [iconDisplay]="'input'"
                        [showIcon]="true"
                        [dateFormat]="'dd/mm/y'"
                        placeholder="DD/MM/YY"
                        size="small"
                        appendTo="body"
                        [minDate]="advancedSearchParameters().dateStart"
                        [maxDate]=""
                        showClear
          ></p-datepicker>
        </div>

        <div class="flex-col gap-2 flex-1 min-w-0">
          <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">TA Type</span></div>
          <p-multi-select [options]="taTypeOptions"
                          appendTo="body"
                          placeholder="Select TA Type"
                          class="w-full"
                          size="small"
                          [(ngModel)]="advancedSearchParameters().taTypeList"
                          showClear
          ></p-multi-select>
        </div>
      </div>

      <div class="flex justify-end gap-2">
        <p-button label="Search" severity="primary" size="small" icon="fa fa-magnifying-glass" (onClick)="search.emit()" [loading]="loading()"></p-button>
        <p-button label="Clear" severity="secondary" size="small" icon="fa fa-x" (onClick)="clear.emit()"></p-button>
      </div>
    </div>
  }
</div>
